/*eslint-disable max-len*/

import React, { PropTypes } from 'react'
import { Layout } from 'components'
import { connect } from 'react-redux'
import NavMenu from './NavMenu'
import { utils, AuthTimer } from 'unity-core'
const { userUtils } = utils
import { toast, ToastContainer } from 'react-toastify';

const propTypes = {
  user: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired //Comes from react-router as the active user link
}
const defaultProps = {}

class App extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    //Apped the provide feedback control from JIRA Issue Collector
    const script = document.createElement('script');
    script.src = 'https://dnb.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/23cn5b/b/19/a44af77267a987a660377e5c46e0fb64/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=02ab2573';
    script.async = true;
    document.body.appendChild(script);
    this.redirectNewAppUrls();
  }

  componentDidUpdate(prevProps) {
    this.redirectNewAppUrls();
  }

  redirectNewAppUrls() {
    const isAuthenticated = userUtils.IsAuthenticated(this.props.user);
    var path = (_.get(this.props, 'location.pathname') || '');
    var search = (_.get(this.props, 'location.search') || '');

    if (isAuthenticated && path.startsWith('/UFlowQuantum')) {
      window.location.href = decodeURIComponent(search ? path + search : path);
    }
  }

  render() {
    return (
      <div>
        {userUtils.IsAuthenticated(this.props.user) ? <AuthTimer /> : null}

        <Layout.Header />
        <div className="slide-top-80">
          {userUtils.IsAuthenticated(this.props.user) ? <NavMenu {...this.props} /> : this.props.children}

          {/*THIS IS WHERE ALL CONTENT WILL BE WRITTEN*/}
        </div>
        <Layout.Footer />
        <ToastContainer position={toast.POSITION.BOTTOM_CENTER} />
      </div>
    );
  }
}

App.propTypes = propTypes
App.defaultProps = defaultProps

const mapStateToProps = (state) => {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(App)
